import gsap from 'gsap'
import { Flip } from 'gsap/dist/Flip'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { DrawSVGPlugin } from 'gsap/dist/DrawSVGPlugin'
import { MotionPathPlugin } from 'gsap/dist/MotionPathPlugin'

gsap.registerPlugin(DrawSVGPlugin, Flip, ScrollTrigger, MotionPathPlugin)

export { gsap, Flip }
